import { Anchor, Breadcrumbs, Title } from '@mantine/core';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { getUiLanguage, tr } from '../lib/i18n';

function crumbsFor(pathname: string): { label: string; to?: string }[] {
  if (pathname.startsWith('/dashboard')) return [{ label: tr('اللوحة الرئيسية', 'Dashboard') }];
  if (pathname.startsWith('/plans')) return [{ label: tr('الباقات', 'Plans') }];
  if (/^\/organizations\/[^/]+/.test(pathname)) return [{ label: tr('الشركات', 'Companies'), to: '/organizations' }, { label: tr('تفاصيل الشركة', 'Company details') }];
  if (pathname.startsWith('/organizations')) return [{ label: tr('الشركات', 'Companies') }];
  if (/^\/forms\/[^/]+\/preview/.test(pathname)) {
    const id = pathname.split('/')[2];
    return [{ label: tr('منشئ النموذج', 'Form builder'), to: '/forms' }, { label: tr('تحرير النموذج', 'Edit form'), to: `/forms/${id}` }, { label: tr('معاينة النموذج', 'Form preview') }];
  }
  if (/^\/forms\/[^/]+/.test(pathname)) return [{ label: tr('منشئ النموذج', 'Form builder'), to: '/forms' }, { label: tr('تحرير النموذج', 'Edit form') }];
  if (pathname.startsWith('/forms')) return [{ label: tr('منشئ النموذج', 'Form builder') }];
  if (['/reference-data', '/property-types', '/categories', '/features', '/locations'].some((p) => pathname.startsWith(p))) return [{ label: tr('البيانات المرجعية', 'Reference data') }];
  if (pathname.startsWith('/overview/properties')) return [{ label: tr('كل العقارات', 'All properties') }];
  if (pathname.startsWith('/overview/requests')) return [{ label: tr('كل الطلبات', 'All requests') }];
  if (pathname.startsWith('/profile')) return [{ label: tr('الحساب', 'Account') }];
  return [];
}

/** The page title; nested pages show the trail above it. */
export function AppBreadcrumbs() {
  const { pathname } = useLocation();
  const items = crumbsFor(pathname);
  if (!items.length) return null;
  const last = items[items.length - 1]!;
  const Sep = getUiLanguage() === 'ar' ? IconChevronLeft : IconChevronRight;
  return (
    <div style={{ minWidth: 0 }}>
      {items.length > 1 && (
        <Breadcrumbs separator={<Sep size={13} />} separatorMargin={4} mb={2}>
          {items.slice(0, -1).map((it) => (
            <Anchor key={it.label} component={RouterLink} to={it.to ?? '#'} size="xs" c="dimmed">{it.label}</Anchor>
          ))}
        </Breadcrumbs>
      )}
      <Title order={1} lineClamp={1}>{last.label}</Title>
    </div>
  );
}
